// extracted by mini-css-extract-plugin
module.exports = {"title":"TwoFactorAuth_title__dNdHO","description":"TwoFactorAuth_description__CnYmY"};